import React, { useState, useEffect } from 'react';
import ReactDOM from "react-dom";
import renderHTML from "react-render-html";
import Helmet from "react-helmet";

export let portals = [];

function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

function createUniversalPortal(children, selector) {
  // server-side. UseEffect handles inserting content into <head> via portal
  if (!canUseDOM()) {
    return null;
  }

  return ReactDOM.createPortal(children, document.querySelector(selector));
}
const Head = (props) => createUniversalPortal(props.children, 'head');

const Snippet = ({ fields, dataSource }) => {
  const [datasource, setDatasource] = useState(dataSource);

  useEffect(() => {
    if (!fields?.placeInHead?.value || fields?.isGTM?.value)
      return;

    if (!canUseDOM()) {
      portals.push([renderHTML(fields.snippet.value), 'head']);
    }
  }, [datasource])

  return (
    fields?.placeInHead?.value
      ? fields?.isGTM?.value
        ? <Helmet><script>{renderHTML(fields.snippet.value)}</script></Helmet>
        : <Head>{renderHTML(fields.snippet.value)}</Head>
      : <div dangerouslySetInnerHTML={{ __html: fields?.snippet.value }}></div>
  );
};

export default Snippet;